import React, { useState, useEffect } from 'react';
import { productsAPI } from '../services/api';
import ProductCard from './ProductCard';
import './css/SaleProductsScroll.css';

const SaleProductsScroll = ({ openCart, products: providedProducts }) => {
  const [saleProducts, setSaleProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSaleProducts = async () => {
      // Use pre-fetched products when provided to avoid extra network calls
      if (providedProducts !== undefined) {
        const saleFiltered = (providedProducts || []).filter(
          (p) => p.salePrice && p.salePrice < p.regularPrice
        );
        setSaleProducts(saleFiltered);
        setLoading(false);
        return;
      }

      try {
        const response = await productsAPI.getAll();
        const productsWithSale = response.data.filter(
          (p) => p.salePrice && p.salePrice < p.regularPrice
        );
        setSaleProducts(productsWithSale);
      } catch (err) {
        console.error('Failed to fetch sale products', err);
      } finally {
        setLoading(false);
      }
    };

    fetchSaleProducts();
  }, [providedProducts]);

  if (loading) {
    return (
      <div className="sale-scroll-loading">
        <div className="skeleton-card"></div>
        <div className="skeleton-card"></div>
        <div className="skeleton-card"></div>
      </div>
    );
  }

  if (saleProducts.length === 0) return null;

  return (
    <section className="sale-products-section">
      <h2 className="sale-section-title">Promos flash</h2>
      <div className="sale-products-scroll">
        {saleProducts.map((product) => (
          <div key={product.id} className="sale-product-wrapper">
            <ProductCard product={product} openCart={openCart} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default SaleProductsScroll;
